import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAutopilotLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 1600,
	height: 395,
	viewBox: "0 0 1600 395",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_14468_141419)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M420.31 311.347H182.634C182.634 311.347 182.601 311.336 182.591 311.32L136.561 232.887C136.539 232.854 136.561 232.811 136.604 232.811H239.717C273.137 232.811 301.301 205.464 300.985 172.044C300.844 156.92 295.118 143.135 285.791 132.642C274.759 120.239 258.694 112.425 240.789 112.425C219.81 112.425 201.339 123.162 190.563 139.423C189.878 140.479 189.208 141.551 188.577 142.65L136.517 232.805L91.1783 311.342H-0.114258L15.9456 283.532L45.2245 232.805L164.495 26.2422C184.784 -8.89791 235.499 -8.89247 255.788 26.2422L255.853 26.3511L301.497 105.42L375.059 232.811L420.354 311.271C420.376 311.303 420.354 311.347 420.31 311.347Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M629.399 265.252H555.434L537.731 311.347H509.344L582.525 126.705H601.796L674.977 311.347H646.852L629.404 265.252H629.399ZM565.072 240.512H619.761L592.414 168.642L565.072 240.512Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M782.531 311.347V292.86C772.114 308.223 756.228 313.431 737.997 313.431C695.287 313.431 676.794 286.607 676.794 246.242V169.159H702.318V246.242C702.318 272.288 708.827 290.259 738.775 290.776C766.378 291.293 781.224 272.022 781.224 247.026V169.159H806.743V311.347H782.525H782.531Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M869.268 126.705V169.154H900.261V189.464H869.268V270.193C869.268 291.287 882.291 292.071 901.039 290.248V311.597C866.928 314.204 843.75 307.167 843.75 269.932V189.464H822.656V169.154H843.75V126.705H869.268Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M982.558 313.948C944.794 313.948 907.031 289.469 907.031 241.034C907.031 192.599 945.056 168.114 983.336 168.114C1021.62 168.114 1058.86 192.593 1058.86 241.034C1058.86 289.475 1020.84 313.948 982.558 313.948ZM982.558 291.037C1008.08 291.298 1033.6 274.367 1033.6 241.034C1033.6 207.701 1008.34 190.775 983.341 190.775C958.346 190.775 932.56 207.445 932.56 241.034C932.56 274.623 957.562 290.776 982.563 291.037H982.558Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1108.61 394.716H1083.09V169.154H1108.61V189.203C1118.76 174.101 1138.04 168.109 1155.74 168.109C1204.96 167.848 1228.66 202.487 1228.66 241.29C1228.66 280.093 1203.66 313.687 1156.01 313.687C1138.56 313.687 1121.11 309.518 1108.61 292.849V394.71V394.716ZM1156.52 291.031C1187.25 290.509 1203.14 266.03 1203.14 241.29C1203.4 215.51 1187 189.725 1154.71 190.503C1131.53 191.026 1108.62 207.957 1108.62 240.767C1108.62 273.578 1132.57 291.287 1156.53 291.026L1156.52 291.031Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1279.46 169.159H1253.94V311.347H1279.46V169.159Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1335.72 311.347H1310.19V126.705H1335.72V311.347Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1433.9 313.948C1396.14 313.948 1358.37 289.469 1358.37 241.034C1358.37 192.599 1396.4 168.114 1434.68 168.114C1472.96 168.114 1510.2 192.593 1510.2 241.034C1510.2 289.475 1472.18 313.948 1433.9 313.948ZM1433.9 291.037C1459.42 291.298 1484.94 274.367 1484.94 241.034C1484.94 207.701 1459.68 190.775 1434.68 190.775C1409.69 190.775 1383.9 207.445 1383.9 241.034C1383.9 274.623 1408.9 290.776 1433.91 291.037H1433.9Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1266.7 152.229C1273.75 152.229 1279.46 146.515 1279.46 139.467C1279.46 132.419 1273.75 126.705 1266.7 126.705C1259.65 126.705 1253.94 132.419 1253.94 139.467C1253.94 146.515 1259.65 152.229 1266.7 152.229Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1568.02 126.705V169.154H1599.01V189.464H1568.02V270.193C1568.02 291.287 1581.04 292.071 1599.79 290.248V311.597C1565.68 314.204 1542.5 307.167 1542.5 269.932V189.464H1521.41V169.154H1542.5V126.705H1568.02Z",
				fill: "black"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_14468_141419",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 1600,
			height: 394.558,
			fill: "white"
		})
	}) })]
});
export default SvgAutopilotLogo;
